export { default } from "./ResourcePageLayout";
export type { ResourcePageLayoutProps } from "./ResourcePageLayout";
